import * as types from './types'
import {RSAA} from "redux-api-middleware";
import {actions} from "../../../common/crud-actions";

const defaultHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

export const authInit = () => {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/me`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.AUTH_INIT,
                types.AUTH_INIT_SUCCESS,
                types.AUTH_INIT_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
};

export const expired = () => {
    return { type: types.AUTH_EXPIRED };
};

export const signIn = (username, password) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/sign-in`,
            method: 'POST',
            body: JSON.stringify({ lecturer: { email: username, password: password } }),
            headers: defaultHeaders,
            types: [
                { type: types.AUTH_SIGN_IN, meta: { type: 'Lecturer' }},
                { type: types.AUTH_SIGN_IN_SUCCESS, meta: { type: 'Lecturer' }},
                types.AUTH_SIGN_IN_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const signOut = () => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/sign-out`,
            method: 'DELETE',
            headers: defaultHeaders,
            types: [
                types.AUTH_SIGN_OUT,
                types.AUTH_SIGN_OUT_SUCCESS,
                types.AUTH_SIGN_OUT_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const register = (values) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.AUTH_REGISTER,
                types.AUTH_REGISTER_SUCCESS,
                types.AUTH_REGISTER_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(values)
        },
        auth: true
    }

};

export const passwordResetRequest = (values) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/password`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.AUTH_PASSWORD_RESET_REQUEST,
                types.AUTH_PASSWORD_RESET_REQUEST_SUCCESS,
                types.AUTH_PASSWORD_RESET_REQUEST_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(values)
        },
        auth: true
    }

};


export const passwordReset = (values) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/password`,
            method: 'PUT',
            headers: defaultHeaders,
            types: [
                types.AUTH_PASSWORD_RESET,
                types.AUTH_PASSWORD_RESET_SUCCESS,
                types.AUTH_PASSWORD_RESET_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(values)
        },
        auth: true
    }

};

export const confirmation = (values) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/confirmation`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.AUTH_CONFIRMATION,
                types.AUTH_CONFIRMATION_SUCCESS,
                types.AUTH_CONFIRMATION_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(values)
        },
        auth: true
    }

};

export const confirmationLink = (token) => {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/confirmation?confirmation_token=${token}`,
            method: 'GET',
            headers: defaultHeaders,
            types: [
                types.AUTH_CONFIRMATION_LINK,
                types.AUTH_CONFIRMATION_LINK_SUCCESS,
                types.AUTH_CONFIRMATION_LINK_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    }

};

export const profileGet = (values) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/profiles/`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.AUTH_PROFILE_GET,
                types.AUTH_PROFILE_GET_SUCCESS,
                types.AUTH_PROFILE_GET_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const profileChange = (values) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/profiles/`,
            method: 'PATCH',
            headers: defaultHeaders,
            body: JSON.stringify({ lecturer: values }),
            types: [
                types.AUTH_PROFILE_CHANGE,
                types.AUTH_PROFILE_CHANGE_SUCCESS,
                types.AUTH_PROFILE_CHANGE_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const passwordChange = (values) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/lecturers/`,
            method: 'PUT',
            headers: defaultHeaders,
            body: JSON.stringify({ lecturer: values }),
            types: [
                types.AUTH_PASSWORD_CHANGE,
                types.AUTH_PASSWORD_CHANGE_SUCCESS,
                types.AUTH_PASSWORD_CHANGE_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const studentSignIn = (username, password) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/student_groups/sign-in`,
            method: 'POST',
            body: JSON.stringify({ student_group: { username: username, password: password } }),
            headers: defaultHeaders,
            types: [
                { type: types.AUTH_SIGN_IN, meta: { type: 'StudentGroup' }},
                { type: types.AUTH_SIGN_IN_SUCCESS, meta: { type: 'StudentGroup' }},
                types.AUTH_SIGN_IN_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};
